import * as d from '../deps'
import React from 'react'

export default function JiraQueryLink(props) {
  let cookie = d.Cookies.get('host')
  let host = cookie || 'http://tenex.bsdpower.com'
  //host = 'http://speed:9393'

  return (
    <a href={`${host}/jira/query?q=${encodeURIComponent(props.q)}`}>
      {props.children}
    </a>
  )
}
